(function() {
  var SppHandler,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  SppHandler = App.loadClass('grower::handlers/placement/SppHandler');

  exports.BurrusSPPSoybeansHandler = (function(superClass) {
    extend(BurrusSPPSoybeansHandler, superClass);

    function BurrusSPPSoybeansHandler() {
      this.customPlantingPlan = bind(this.customPlantingPlan, this);
      return BurrusSPPSoybeansHandler.__super__.constructor.apply(this, arguments);
    }

    BurrusSPPSoybeansHandler.prototype.init = function() {
      this.customStepFunctions = {
        step_3: {
          afterEnter: this.stepFunctions.addSoybeanMaturityValidation
        }
      };
      this.hybridButtonContents = {
        title: 'seed_company_name',
        table: {
          'Brand': 'display_name',
          'Trait': 'trait_summary',
          'RM': 'soybean_maturity'
        }
      };
      this.customButtons = [
        {
          'html': '<button class="btn btn-blue" id="pdf_button" data-loading-text="Generating report..."> <i class="fa fa-file-o"></i> Placement Summary Report </button>',
          'click': (function(_this) {
            return function() {
              var layers;
              layers = _this.curStep.stepKO.plantingPlans();
              return _this.actionPdf(layers, false, '#long_pdf_button');
            };
          })(this)
        }, {
          'html': '<br /> <button class="btn btn-blue" style="margin-top: 10px;" id="long_pdf_button" data-loading-text="Generating report..."> <i class="fa fa-file-o"></i> Placement Summary Detail Report </button>',
          'click': (function(_this) {
            return function() {
              var layers;
              layers = _this.curStep.stepKO.plantingPlans();
              return _this.actionPdf(layers, true, '#long_pdf_button');
            };
          })(this)
        }
      ];
      return BurrusSPPSoybeansHandler.__super__.init.call(this);
    };

    BurrusSPPSoybeansHandler.prototype.customPlantingPlan = function(field_id, plan, notes_obj) {
      var notesFn, products, ref, static_notes, tmt_id;
      products = this.taffyObjects.hybrids;
      tmt_id = (ref = this.getFieldAspectByName(field_id, 'Treatment Application')) != null ? ref.value : void 0;
      this._customProductSubscription = function(stage, product_id) {
        var product, ref1, selected_tmt;
        selected_tmt = _.filter((ref1 = stage.product) != null ? ref1.treatments : void 0, {
          id: tmt_id
        })[0];
        if (selected_tmt) {
          stage.treatment = selected_tmt;
        } else {
          product = products({
            id: parseInt(product_id)
          }).first();
          stage.treatment = product != null ? product.default_treatment_id : void 0;
        }
        return notesFn();
      };
      static_notes = 'You may need to adjust planting population depending ' + 'upon field conditions and treatment choice<br/>';
      notesFn = function() {
        var notes, product, product_id, ref1, ref2, ref3;
        product_id = (ref1 = plan.events[0]) != null ? (ref2 = ref1.stages[0]) != null ? (ref3 = ref2.product) != null ? ref3.id : void 0 : void 0 : void 0;
        product = products({
          id: parseInt(product_id)
        }).first();
        notes = '';
        if (product != null ? product.description : void 0) {
          notes += product.description + '<br/>';
        }
        return notes_obj.notes = notes + static_notes;
      };
      return this._customPopulationAdjustment = function(event, population) {
        var product, product_id, ref1, ref2, ref3, ref4, tmt_options;
        product_id = (ref1 = event.stages[0]) != null ? (ref2 = ref1.product) != null ? ref2.id : void 0 : void 0;
        product = products({
          id: parseInt(product_id)
        }).first();
        tmt_options = (ref3 = product != null ? product.available_treatments : void 0) != null ? ref3 : [];
        if ((typeof tmt_aspect !== "undefined" && tmt_aspect !== null ? tmt_aspect.option_name : void 0) === 'Untreated' && (ref4 = typeof tmt_aspect !== "undefined" && tmt_aspect !== null ? tmt_aspect.value : void 0, indexOf.call(tmt_options, ref4) >= 0)) {
          return population * 1.18;
        } else {
          return population;
        }
      };
    };

    return BurrusSPPSoybeansHandler;

  })(SppHandler);

}).call(this);
